import { http, URL } from "./http.service";
import { errorHandler } from "./error.service";

// Get risk settings for a business
export const getRiskSettings = async (businessUuid) => {
  try {
    const resp = await http.get(`${URL}/risk-settings/${businessUuid}`);
    return resp.data;
  } catch (error) {
    console.error("Error fetching risk settings:", error);
    errorHandler(error);
    throw error;
  }
};

// Get risk settings summary (quick view)
export const getRiskSettingsSummary = async (businessUuid) => {
  try {
    const resp = await http.get(`${URL}/risk-settings/${businessUuid}/summary`);
    return resp.data;
  } catch (error) {
    console.error("Error fetching risk settings summary:", error);
    errorHandler(error);
    throw error;
  }
};

// Get checkout-specific risk settings
export const getCheckoutRiskSettings = async (businessUuid) => {
  try {
    const resp = await http.get(`${URL}/risk-settings/${businessUuid}/checkout`);
    return resp.data;
  } catch (error) {
    console.error("Error fetching checkout risk settings:", error);
    errorHandler(error);
    throw error;
  }
};

// Update risk settings
export const updateRiskSettings = async (businessUuid, settingsData) => {
  try {
    const resp = await http.put(`${URL}/risk-settings/${businessUuid}`, settingsData);
    return resp.data;
  } catch (error) {
    console.error("Error updating risk settings:", error);
    errorHandler(error);
    throw error;
  }
};

// Reset risk settings to default
export const resetRiskSettings = async (businessUuid) => {
  try {
    const resp = await http.post(`${URL}/risk-settings/${businessUuid}/reset`);
    return resp.data;
  } catch (error) {
    console.error("Error resetting risk settings:", error);
    errorHandler(error);
    throw error;
  }
};

// Update pincode block list
export const updatePincodeBlockList = async (businessUuid, pincodes, action = 'replace') => {
  try {
    const resp = await http.patch(`${URL}/risk-settings/${businessUuid}/pincodes`, {
      pincodes,
      action,
    });
    return resp.data;
  } catch (error) {
    console.error("Error updating pincode block list:", error);
    errorHandler(error);
    throw error;
  }
};